import Header from '../../../Shared-Component/Header/Header'
import Footer from '../../../Shared-Component/Footer/Footer'
import CampusSlashTitle from '../../CampusSharedComponent/CampusTitles/CampusSlashTitle/CampusSlashTitle'
import CampusDynamicSection from '../../CampusSharedComponent/CampusSections/CampusDynamicSection/CampusDynamicSection'
import auditorium from "../../../assets/CampuLifeImages/auditorium.JPG"




const Auditorium = () => {
   const libraryData = {
    img: auditorium,
    content: "A college auditorium is a large, versatile space designed to accommodate a variety of events, from academic lectures and presentations to cultural performances and ceremonies. It's a central hub on campus, facilitating communication, learning, and community engagement. It is typically equipped with a stage, seating, and advanced audio-visual systems to support diverse activities."
  }
   
  
  return (
    <>
      <div>
        <Header />
        <div className='campus-container'>
        <div className='campusmaincontainer'>
                 <CampusSlashTitle slashTitle="Auditorium" />
          <CampusDynamicSection data={libraryData} />
          </div>
          <Footer />
        </div>
      </div>

    </>
  )
}

export default Auditorium